module.exports = __webpack_public_path__ + "img/confirm.252b0159.gif";